import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ValList } from '@/common/val/ValList';
import { McdDispList } from '../mcdDisp/McdDispList';

export const McdClaimLineDetail = () => {

  const { entityObj } = useEntityMgr();
  const { navState } = useNavState();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'claim', label: 'Claim', content: <EntityForm entity="MCD_CLAIM" entityId={entityObj.mcdClaimId} /> },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="MCD_CLAIM_LINE" parentEntityId={entityObj.id} partition={navState.partition} /> },
    { id: 'disps', label: 'Disputes', content: <McdDispList mcdClaimLineId={entityObj.id} partition={navState.partition} /> },
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}